import {FC} from 'react';
import {IDocViewDocListRowData} from '../interfaces';
import {Box} from '@mui/material';

import {ReactComponent as CompletedIcon} from '../../../../../src/assets/images/selected-base-icon.svg';
import {ReactComponent as LinkIcon} from '../../../../../src/assets/images/link-base-icon.svg';
import './ActionCell.scss';
import ArrCheckbox from '../../../common/arr-checkbox/ArrCheckbox';
import React from 'react';
type ActionCellProps = {
  rowData: IDocViewDocListRowData;
  onCheckboxClick: (arg0: IDocViewDocListRowData) => void;
  actionCellId?: string;
};
const ActionCell: FC<ActionCellProps> = ({
  rowData,
  onCheckboxClick,
  actionCellId,
}) => {
  const testId = actionCellId ?? rowData?.RowNumber;
  return (
    <Box className="doc-view-doc-list-action-cell">
      <ArrCheckbox
        checked={Boolean(rowData.IsChecked)}
        onClick={(e) => {
          e.stopPropagation();
          onCheckboxClick(rowData);
        }}
        onKeyDown={(e) => {
          e.stopPropagation();
          if (e.key === 'Enter') {
            e.preventDefault();
            onCheckboxClick(rowData);
          }
        }}
        size="medium"
        borderRadius={2}
        aria-label={`checkbox-${testId}`}
        data-testid={`action-cell-arr-checkbox-${testId}`}
      />
      {rowData.IsCompleted && (
        <CompletedIcon
          className="completed-icon"
          data-testid={`completed-${testId}`}
        />
      )}
      {rowData.IsCodeSame && (
        <LinkIcon className="link-icon" data-testid={`link-${testId}`} />
      )}
    </Box>
  );
};

export default React.memo(ActionCell);
